<!--
  ===============================================================
  Template du dialog de sélection de créneau
  ===============================================================

  STRUCTURE :
  - Header sticky
  - Sélecteur de date
  - Sélecteur de créneau
  - Bouton fermeture

  NOTE :
  L’affichage est volontairement compact pour éviter un scroll
  excessif quand un jour contient beaucoup de créneaux.
-->

<div class="rounded-2xl border border-gray-200 bg-white shadow-sm overflow-hidden">

  <!-- HEADER -->
  <div class="sticky top-0 z-10 bg-white border-b border-gray-200 p-4">

    <!-- Titre + contexte -->
    <div class="flex items-start justify-between gap-3">
      <div>
        <h2 class="text-lg font-semibold text-gray-900">
          Choisir un créneau
        </h2>
        <div class="text-xs text-gray-500 mt-1">
          {{ data.pos.denomination }} • {{ data.sm.name }}
        </div>
      </div>

      <!-- Fermeture -->
      <button mat-icon-button type="button"
              (click)="close()"
              aria-label="Fermer">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Raccourci UX -->
    <div class="mt-3 flex gap-2">
      <button mat-stroked-button
              type="button"
              (click)="pickNext()"
              [disabled]="!hasGroups">
        Prochain créneau
      </button>
    </div>

  </div>

  <!-- CONTENU -->
  <mat-dialog-content class="p-4">

    <!-- Aucun créneau -->
    <div *ngIf="!hasGroups"
         class="text-sm text-gray-600">
      Aucun créneau disponible.
    </div>

    <!-- Sélection -->
    <div *ngIf="hasGroups">

      <!-- Sélecteur date -->
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Date</mat-label>
        <mat-select [(ngModel)]="dayIndex">
          <mat-option *ngFor="let g of data.groups; let i = index"
                      [value]="i">
            {{ dayLabel(g) || (g.date | date:'EEE d MMM') }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Sélecteur créneau -->
      <mat-form-field appearance="outline"
                      class="w-full mt-3">
        <mat-label>Créneau</mat-label>
        <mat-select (selectionChange)="pick($event.value)">
          <mat-option *ngFor="let s of data.groups[dayIndex]?.slots"
                      [value]="s">
            {{ s.start | date:'HH:mm' }} → {{ s.end | date:'HH:mm' }}
          </mat-option>
        </mat-select>
      </mat-form-field>

    </div>

  </mat-dialog-content>

</div>